const STORAGE_KEY = "md-stale-chunk-reload-at";

/** Finestra anti-loop: entro questo intervallo non ricarichiamo una seconda volta. */
const RELOAD_WINDOW_MS = 30_000;

/**
 * Guardia anti-deploy: dopo un deploy i chunk lazy con hash vecchi non esistono
 * più sul server e le schede rimaste aperte falliscono il dynamic import
 * (schermata bianca). Vite emette `vite:preloadError` in quel caso: ricarichiamo
 * la pagina UNA volta per prendere l'index nuovo. Il timestamp in sessionStorage
 * evita loop di reload se l'errore persiste (es. rete giù), pur permettendo
 * il recupero automatico a un deploy successivo nella stessa scheda.
 */
export function installStaleChunkGuard(): void {
  window.addEventListener("vite:preloadError", (event) => {
    const lastReload = Number(sessionStorage.getItem(STORAGE_KEY) ?? 0);
    if (Date.now() - lastReload < RELOAD_WINDOW_MS) return; // già ricaricato: lascia emergere l'errore
    sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
    event.preventDefault(); // evita che Vite propaghi l'errore mentre ricarichiamo
    window.location.reload();
  });
}
